export const RESET_GIFTS = 'gifts/RESET';

export const FETCH_GIFTS_PRODUCTS_BY_FILTERS =
  'gifts/FETCH_GIFTS_PRODUCTS_BY_FILTERS';
export const FETCH_GIFTS_PRODUCTS_BY_FILTERS_SUCCESS =
  'gifts/FETCH_GIFTS_PRODUCTS_BY_FILTERS_SUCCESS';
export const FETCH_GIFTS_PRODUCTS_BY_FILTERS_FAILED =
  'gifts/FETCH_GIFTS_PRODUCTS_BY_FILTERS_FAILED';

export const SET_GIFTS_PRODUCTS_PARAMS = 'gifts/SET_GIFTS_PRODUCTS_PARAMS';
export const SET_GIFTS_PRODUCTS_PAGE = 'gifts/SET_GIFTS_PRODUCTS_PAGE';
export const RESET_GIFTS_PRODUCTS = 'gifts/RESET_GIFTS';

export const PRICE_FILTER_CAN_BE_SENT = 'gifts/PRICE_FILTER_CAN_BE_SENT';

export const FETCH_PRODUCT_DETAILS = 'gifts/FETCH_PRODUCT_DETAILS';
export const FETCH_PRODUCT_DETAILS_SUCCESS =
  'gifts/FETCH_PRODUCT_DETAILS_SUCCESS';
export const FETCH_PRODUCT_DETAILS_FAILED =
  'gifts/FETCH_PRODUCT_DETAILS_FAILED';

export const FETCH_PRODUCTS_BY_RECOMMENDATIONS =
  'gifts/FETCH_PRODUCTS_BY_RECOMMENDATIONS';
export const FETCH_PRODUCTS_BY_RECOMMENDATIONS_SUCCESS =
  'gifts/FETCH_PRODUCTS_BY_RECOMMENDATIONS_SUCCESS';
export const FETCH_PRODUCTS_BY_RECOMMENDATIONS_FAILED =
  'gifts/FETCH_PRODUCTS_BY_RECOMMENDATIONS_FAILED';

export const FETCH_PRODUCTS_OF_SELECTED_CATEGORY =
  'gifts/FETCH_PRODUCTS_OF_SELECTED_CATEGORY';
export const FETCH_PRODUCTS_OF_SELECTED_CATEGORY_SUCCESS =
  'gifts/FETCH_PRODUCTS_OF_SELECTED_CATEGORY_SUCCESS';
export const FETCH_PRODUCTS_OF_SELECTED_CATEGORY_FAILED =
  'gifts/FETCH_PRODUCTS_OF_SELECTED_CATEGORY_FAILED';

export const SET_RECOMMENDED_CATEGORY = 'gifts/SET_RECOMMENDED_CATEGORY';

export const SET_SHOW_RECOMMENDATIONS = 'gifts/SET_SHOW_RECOMMENDATIONS';
export const SET_WITH_RECOMMENDATIONS = 'gifts/WITH_RECOMMENDATIONS';

export const CHANGE_RECOMMENDATION_PRODUCT_PAGE =
  'gifts/CHANGE_RECOMMENDATION_PRODUCT_PAGE';
export const CHANGE_RECOMMENDATION_PRODUCT_ORDER =
  'gifts/CHANGE_RECOMMENDATION_PRODUCT_ORDER';

export const FETCH_DYNAMIC_CONFIGURATION = 'gifts/FETCH_DYNAMIC_CONFIGURATION';
export const FETCH_DYNAMIC_CONFIGURATION_SUCCESS =
  'gifts/FETCH_DYNAMIC_CONFIGURATION_SUCCESS';
export const FETCH_DYNAMIC_CONFIGURATION_FAILED =
  'gifts/FETCH_DYNAMIC_CONFIGURATION_FAILED';
export const FETCH_DYNAMIC_CONFIGURATION_EMPTY =
  'gifts/FETCH_DYNAMIC_CONFIGURATION_EMPTY';

export const FETCH_PRODUCTS_DYNAMIC_CONFIG =
  'gifts/FETCH_PRODUCTS_DYNAMIC_CONFIG';
export const FETCH_PRODUCTS_DYNAMIC_CONFIG_SUCCESS =
  'gifts/FETCH_PRODUCTS_DYNAMIC_CONFIG_SUCCESS';
export const FETCH_PRODUCTS_DYNAMIC_CONFIG_FAILED =
  'gifts/FETCH_PRODUCTS_DYNAMIC_CONFIG_FAILED';
